import { replaceSlashWithAsciiChar } from './resolveBranch';
export function getRepositoryOwner(repository) {
    const repositoryNameIndexBy = repository.slug ? repository.slug : '/';
    const repositoryOwnerRaw = repository.fullname.substring(0, repository.fullname.lastIndexOf(repositoryNameIndexBy));
    const repositoryOwnerRawLength = repositoryOwnerRaw.length - 1;
    const replaceLastSlash = repositoryOwnerRaw.lastIndexOf('/') === repositoryOwnerRawLength;
    return replaceLastSlash ? repositoryOwnerRaw.substring(0, repositoryOwnerRawLength) : repositoryOwnerRaw;
}
export function formatRepositoryUrl(fullname) {
    const index = fullname.lastIndexOf('/');
    const owner = replaceSlashWithAsciiChar(fullname.substring(0, index));
    const repositoryName = replaceSlashWithAsciiChar(fullname.substring(index + 1));
    return `${owner}/${repositoryName}`;
}
export function handleBranchInUrl(history, match, fullname, repositorySlug, mainBranch, activeBranch) {
    let url = match.url;
    const branchName = match.params.branch;
    if (activeBranch && url.includes(replaceSlashWithAsciiChar(activeBranch))) {
        return;
    }
    if (url === '/') {
        url = window.location.pathname;
    }
    let restOfUrl = '';
    const clearRepositoryName = repositorySlug.replace(/\/./g, '-');
    const compareRepositoryName = `/${clearRepositoryName}`;
    if (url.includes(fullname) && fullname.includes(compareRepositoryName)) {
        const index = url.lastIndexOf(fullname);
        restOfUrl = url.substring(index + fullname.length);
    }
    else {
        const lastIndex = url.endsWith(`${compareRepositoryName}/`) || url.includes(`${compareRepositoryName}/`)
            ? url.lastIndexOf(`${compareRepositoryName}/`)
            : url.lastIndexOf(`${compareRepositoryName}`);
        restOfUrl = url.substring(lastIndex + 1 + clearRepositoryName.length); // 1 because of slash
    }
    if (!branchName) {
        history.replace(`/${match.params.vcs}/${fullname}${restOfUrl}`);
    }
    else if (mainBranch &&
        activeBranch &&
        activeBranch !== mainBranch &&
        branchName !== 'commits') {
        history.replace(`/${match.params.vcs}/${fullname}/b-${activeBranch}${restOfUrl}`);
    }
    else if (!fullname.includes(restOfUrl)) {
        history.replace(`/${match.params.vcs}/${fullname}${restOfUrl}`);
    }
}
